module.exports = __webpack_public_path__ + "statics/img/cate6-2@2x.dda07f9a.png";